import { useCallback, useEffect, useState } from 'react'
import "./case_category.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { useNavigate, useParams } from 'react-router-dom';
import { BaseUrl } from '../../helper/BaseUrl';

const caseCategoryEditEndpoint = ApiEndpoints.caseCategory.caseCategoryEdit;
const caseCategoryUpdateEndPoint = ApiEndpoints.caseCategory.caseCategoryUpdate;

export default function EditCaseCategory() {
  const { casecategory_id } = useParams();
  const [postData, setPostData] = useState({ name: "", image: null, alt_image: "", casestudycategory_id: casecategory_id });
  const navigate = useNavigate();
  const [preview, setPreview] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    // File input
    if (files && files.length > 0) {
      const file = files[0];

      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));

      // image preview
      setPreview(URL.createObjectURL(file));
    }
    // Text input
    else {
      setPostData((prev) => ({
        ...prev,
        casestudycategory_id: casecategory_id,
        [name]: value,
      }));
    }
  };

  const dataFetch = useCallback(
    async () => {
      try {
        const response = await ApiRequest(
          "GET",
          `${caseCategoryEditEndpoint}${casecategory_id}`
        );
        const result = response.casestudycategory;
        setPreview(BaseUrl + result?.image);
        setPostData(prev => ({
          ...prev,
          ...result,
          casestudycategory_id: casecategory_id,
        }));
      } catch (error) {
        console.log(error);
      }
    }, [casecategory_id]);

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();

      try {
        const formData = new FormData();
        Object.entries(postData).forEach(([key, value]) => {
          formData.append(key, value);
        });

        await ApiRequest("POST", caseCategoryUpdateEndPoint, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        navigate("/admin/case-category");
      } catch (error) {
        console.log(error);
      }
    },
    [postData, navigate]
  );

  return (
    <>
      <div className="header-add-category">
        <h5>Edit Case Category</h5>
      </div>
      <div className="add-mediacat-content">
        <form onSubmit={handleSubmit}>
          <div className="row">

            {/* Title Input */}
            <div className="col-md-12">
              <label>Case Category:</label>
              <input
                type="text"
                name='name'
                value={postData.name}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>

            <div className="col-md-12">
              <label>Image (336 × 306 px):</label>
              <input
                type="file"
                name='image'
                onChange={handleChange}
                className="form-control"
              />
            </div>

            {preview && (
              <div className="mt-2">
                <img
                  src={preview}
                  alt="Preview"
                  style={{ width: "150px", borderRadius: "6px" }}
                />
              </div>
            )}

            <div className="col-md-12">
              <label>Alt Image:*</label>
              <input
                type="text"
                name='alt_image'
                value={postData.alt_image}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>

            {/* Submit Button */}
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary submit-formbtn">
                edit case category
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
